import { create } from "zustand";

interface Props {
  state: boolean;
  open: () => void;
  close: () => void;
  toggle: (value?: boolean) => void;
}
const useDrawerStore = create<Props>((set) => ({
  state: false,
  open: () => set({state: true}),
  close: () => set({state: false}),
  toggle: (state) => {
    if(state == undefined) {
      set((value) => ({state: !value.state}));
      
    }
    else set({state});
  }
}));

export default useDrawerStore;
